export const permissionsArrayToMap = (array, key = 'id') =>
  array.reduce((map, item) => ({ ...map, [item[key]]: item.permissions }), {});
